import styled from "@emotion/styled"
import slogan from './assets/slogan.png'
import content from './assets/content.png'
import networkflow from './assets/networkflow.png'
import finance from './assets/finance.png'
import cp1 from './assets/cp1.png'
import prev from './assets/prev.png'
import next from './assets/next.png'
import beijing from './assets/beijing.png'
import shanghai from './assets/shanghai.png'
import shenzhen from './assets/shenzhen.png'
import jinrongqihuo from './assets/jinrongqihuo.png'
import zhongyangjiesuan from './assets/zhongyangjiesuan.png'
import zhongzhai from './assets/zhongzhai.png'
import jinrongrenzheng from './assets/jinrongrenzheng.png'
import yinhe from './assets/yinhe.png'
import guangda from './assets/guangda.png'
import mayi from './assets/mayi.png'
import guotaijunan from './assets/guotaijunan.png'
import zhongxin from './assets/zhongxin.png'
import changjiang from './assets/changjiang.png'
import huatai from './assets/huatai.png'
import zhongxinjiantou from './assets/zhongxinjiantou.png'
import zhongtai from './assets/zhongtai.png'
import dacheng from './assets/dacheng.png'
import fuguo from './assets/fuguo.png'
import haifutong from './assets/haifutong.png'
import penghua from './assets/penghua.png'
import boshi from './assets/boshi.png'
import nuode from './assets/nuode.png'
import nongyin from './assets/nongyin.png'
import yinhua from './assets/yinhua.png'
import dajia from './assets/dajia.png'
import nanfang from './assets/nanfang.png'
import yifangda from './assets/yifangda.png'
import taikang from './assets/taikang.png'
import { Button, Carousel } from "antd"
import { useRef } from "react"
import { CarouselRef } from "antd/lib/carousel"
import { BusinessSummary, CenterBox, SectionTitle } from "./compnents"

interface CustomerData {
    img: string
    name: string
}

interface CarouselPageProps {
    customers: CustomerData[]
}

const CarouselPage = (props: CarouselPageProps) => {
    const { customers } = props
    return <div>
        <CustomerPage>
            {
                customers.map((item, index) => {
                    return <Customer key={index}><CustomerLogo src={item.img} alt={item.name} /></Customer>
                })
            }
        </CustomerPage>
    </div >
}

export const HomePage = () => {
    const carousel = useRef<CarouselRef>(null)

    const customers = [
        { img: beijing, name: '北京证券交易所' },
        { img: shanghai, name: '上海证券交易所' },
        { img: shenzhen, name: '深圳证券交易所' },
        { img: jinrongqihuo, name: '中国金融期货交易所' },
        { img: zhongyangjiesuan, name: '中央结算公司' },
        { img: zhongzhai, name: '中债金融估值中心' },
        { img: jinrongrenzheng, name: '中国金融认证中心' },
        { img: mayi, name: '蚂蚁金服' },
        { img: dajia, name: '大家保险' },
        { img: taikang, name: '泰康' },
        { img: guangda, name: '光大证券' },
        { img: guotaijunan, name: '国泰君安证券' },
        { img: zhongxin, name: '中信证券' },
        { img: changjiang, name: '长江证券' },
        { img: yinhe, name: '中国银河证券' },
        { img: huatai, name: '华泰证券' },
        { img: zhongxinjiantou, name: '中信建投证券' },
        { img: zhongtai, name: '中泰证券' },
        { img: yifangda, name: '易方达' },
        { img: dacheng, name: '大成基金' },
        { img: fuguo, name: '富国基金' },
        { img: haifutong, name: '海富通基金' },
        { img: boshi, name: '博时基金' },
        { img: penghua, name: '鹏华基金' },
        { img: nuode, name: '诺德基金' },
        { img: nongyin, name: '农银汇理基金' },
        { img: yinhua, name: '银华基金管理股份有限公司' },
        { img: nanfang, name: '南方财经网' }
    ]

    const customersPages = []
    for (var i = 0; i < customers.length; i += 16) {
        customersPages.push(customers.slice(i, i + 16))
    }

    return <div>
        <Slogan>
            <CenterBox style={{ top: '14.8rem', flexDirection: 'column', alignItems: 'center' }}>
                <img src={slogan} alt={'Slogan'} style={{ objectFit: 'cover', marginRight: '80px' }} />
                <div className={'sy-bold'} style={{ letterSpacing: '0.1rem' }}>
                    <span style={{ fontSize: '2.4rem', paddingRight: '0.8rem', color: '#c9b17a' }}>VISION</span>
                    <span style={{ fontSize: '2.4rem', paddingLeft: '0.8rem', color: '#c5c5c5' }}>VALUE</span>
                </div>
                <h2 style={{ color: '#1e1e1e', letterSpacing: '0.5rem', fontWeight: 'bold' }}>远见未来</h2>
                <h3 style={{ fontWeight: 'normal', color: '#1e1e1e' }}>金融数字内容服务提供商</h3>
            </CenterBox>
        </Slogan>
        <MainBusiness>
            <SectionTitle top={'10.4rem'} title={'主营业务'} subTitleLeft={'MAIN'} subTitleRight={'BUSINESS'} />

            <CenterBox style={{ top: '27rem', justifyContent: 'space-around', padding: '0 12%' }}>
                <BusinessSummary img={content} title={'内容服务'} content={'财经视频内容，产品视频、企业宣传视频制作，动画和图文制作，财经 IP 打造，版权服务等'} />
                <BusinessSummary img={networkflow} title={'流量管理'} content={'专业财经直播服务，B端金融机构数字内容整合营销'} />
                <BusinessSummary img={finance} title={'金融科技服务'} content={'交互视频研发，研报、财报、公告等金融数据可视化及分析，远见直播系统'} />
                {/* <BusinessSummary img={quotient} title={'财商教育产品'} content={'金融机构财商教育课程开发、覆盖成人及青少年机构的财商教育产品'} /> */}
            </CenterBox>
        </MainBusiness>
        <CompanyDynamics>
            <SectionTitle top={'5.6rem'} title={'公司动态'} subTitleLeft={'COMPANY'} subTitleRight={'DYNAMICS'} />
            <CenterBox style={{ top: '19rem', padding: '0 12%' }}>
                <img src={cp1} alt={'cp1'} />
                <div style={{ fontFamily: 'sy-bold', fontSize: '2rem', marginLeft: '5rem', marginTop: '2rem' }}>
                    <CPItem><SquareDot /><CPDate>2021-12-6</CPDate><span>远见未来与易方达基金管理有限公司达成年度战略合作</span></CPItem>
                    <CPItem><SquareDot /><CPDate>2021-9-20</CPDate><span>远见未来与南财集团达成年度战略合作</span></CPItem>
                    <CPItem><SquareDot /><CPDate>2021-6-12</CPDate><span>北京市委书记蔡奇莅临丽泽金融商务区调查研究</span></CPItem>
                </div>
            </CenterBox>
        </CompanyDynamics>
        <OurCustomers>
            <SectionTitle top={'5.6rem'} title={'服务客户'} subTitleLeft={'OUR'} subTitleRight={'CUSTOMERS'} />
            <CenterBox style={{ top: '18rem', justifyContent: 'center', alignItems: 'center' }}>
                <Button onClick={() => carousel.current?.prev()} style={{ height: '6.07rem' }} type={'link'}><img src={prev} alt={'<'} /></Button>
                <div style={{ width: '109rem' }} >
                    <Carousel ref={carousel} autoplay={false}>
                        {
                            customersPages.map((page, index) => {
                                return <CarouselPage customers={page} key={index} />
                            })
                        }
                    </Carousel>
                </div>
                <Button onClick={() => carousel.current?.next()} style={{ height: '6.07rem' }} type={'link'}><img src={next} alt={'>'} /></Button>
            </CenterBox >
        </OurCustomers >
    </div >
}

const Slogan = styled.div`
position: relative;
height: 82.6rem;
`

const MainBusiness = styled.div`
position: relative;
height: 79.5rem;
background-color: #f6f6f6;
`

const CompanyDynamics = styled.div`
position: relative;
background-color: white;
height: 47rem;    
`


const OurCustomers = styled.div`
position: relative;
background-color: white;
height: 87.4rem;
`

const CustomerPage = styled.div`
display: flex;
flex-wrap: wrap;
width: 108rem;
justify-content: space - around;
`

const Customer = styled.div`
display: flex;
width: 24.7rem;
height: 10.5rem;
border: solid;
border-width: 0.2rem;
border-color: #ebe3f0;
border-radius: 0.8rem;
padding: 1rem;
margin: 1rem;
justify-content: center;
align-items: center;
`

const CustomerLogo = styled.img`
max-width: 24rem;
object-fit: cover;
`

const SquareDot = styled.div`
width: 0.6rem;
height: 0.6rem;
background-color: #cdb785;
margin-right: 3rem;
`

const CPItem = styled.div`
display: flex;
justify-Content: flex-start;
align-Items: center;
margin-bottom: 2rem;
`

const CPDate = styled.span`
color: #cdb785;
width: 13rem;
`